<template>
  <div v-if="!selecionouPerguntaIpi">
    <!-- NAO TRIBUTADA -->
    <div v-if="!!naoTributada && !selecionouPerguntaIpi">
      <Registro class="nao-tributada" paddingSemCheckBox>
        <Cabecalho :titulo="naoTributada.label" :aliquota="'NT'" />
        <div class="separador" />

        <GrupoNotificacao v-if="naoTributada" :registro="naoTributada" />

        <div
          class="separador"
          v-if="
            naoTributada.obs ||
              naoTributada.obs_aplic ||
              naoTributada.obs_inaplic ||
              naoTributada.nota
          "
        />

        <BaseLegal :base_legal="naoTributada.base_legal" />
      </Registro>
      <div class="separador-ipi" />

      <Cabecalho
        class="cabecalho-nao-tributada"
        :titulo="
          'Para fins dos demais tributos, selecione a hipótese correspondente a sua operação:'
        "
      />
    </div>
    <!-- OPCOES DE PERGUNTA IPI -->
    <div class="ipi-perguntas-content" v-for="pergunta in perguntasFiltradasIndusrial">
      <RadioButton
        v-if="perguntasFiltradasIndusrial.length > 0"
        :classe="imposto.classe"
        :seleciona="seleciona"
        :imposto="pergunta"
      />
      <Registro :paddingSemCheckBox="perguntasFiltradasIndusrial.length <= 1">
        <Cabecalho :titulo="pergunta.descricao" />
        <!-- <div class="separador" v-if="pergunta.descricao && pergunta.base_legal"/>
        <BaseLegal v-if="pergunta.base_legal" :base_legal="pergunta.base_legal" /> -->
      </Registro>
    </div>

    <div v-if="perguntasFiltradasIndusrial.length" class="separador-ipi" />

    <Registro v-if="perguntasFiltradasEquiparadoIndusrial.length > 0" paddingSemCheckBox>
      <div class="cabecalho-equiparado-industrial" v-if="labelEquiparadoIndustrial">
        <Cabecalho :titulo="labelEquiparadoIndustrial.descricao" />
        <div class="separador" />
        <Cabecalho :titulo="'Hipóteses de equiparação a industrial:'" />
      </div>

      <div
        class="ipi-perguntas-content"
        v-for="(pergunta, index) in perguntasFiltradasEquiparadoIndusrial"
      >
        <RadioButton
          v-if="imposto.perguntas.length > 1"
          :classe="imposto.classe"
          :seleciona="seleciona"
          :imposto="pergunta"
        />
        <Registro :paddingSemCheckBox="perguntasFiltradasEquiparadoIndusrial.length <= 1">
          <Cabecalho :titulo="pergunta.descricao" />
        </Registro>
      </div>
    </Registro>
  </div>
  <!-- PERGUNTA IPI SELECIONADA -->
  <div
    class="ipi-perguntas-content"
    v-else-if="
      !!perguntasFiltradasIndusrial.length || !!perguntasFiltradasEquiparadoIndusrial.length
    "
  >
    <EditButton
      v-if="
        perguntasFiltradasIndusrial.length > 1 || perguntasFiltradasEquiparadoIndusrial.length > 1
      "
      :classe="imposto.classe"
      :edita="edita"
    />

    <Registro
      :paddingSemCheckBox="
        perguntasFiltradasIndusrial.length <= 1 && perguntasFiltradasEquiparadoIndusrial.length <= 1
      "
    >
      <Cabecalho :titulo="perguntaSelecionada.descricao" />
      <GrupoNotificacao v-if="perguntaSelecionada" :registro="perguntaSelecionada" />

      <div
        class="separador"
        v-if="
          (perguntaSelecionada.descricao ||
            perguntaSelecionada.obs ||
            perguntaSelecionada.obs_aplic ||
            perguntaSelecionada.obs_inaplic ||
            perguntaSelecionada.nota) &&
            perguntaSelecionada.base_legal
        "
      />

      <BaseLegal :base_legal="perguntaSelecionada.base_legal" />
    </Registro>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import Registro from "@/components/Registro/Registro.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

export default {
  name: "PerguntasIpi",

  props: {
    imposto: Array | Object,
    seleciona: Function,
    edita: Function,
    perguntaSelecionada: Object,
    selecionouPerguntaIpi: Boolean
  },

  components: {
    BaseLegal,
    Cabecalho,
    EditButton,
    Notificacao,
    GrupoNotificacao,
    RadioButton,
    Registro,
    Separador
  },

  data() {
    return {};
  },

  created() {
    if (
      this.perguntasFiltradasIndusrial &&
      this.perguntasFiltradasIndusrial.length == 1 &&
      !this.selecionouPerguntaIpi
    ) {
      this.seleciona(this.perguntasFiltradasIndusrial[0]);
    } else if (
      this.imposto.perguntas &&
      this.imposto.perguntas.length == 1 &&
      !this.selecionouPerguntaIpi
    ) {
      this.seleciona(this.imposto.perguntas[0]);
    }
    // console.log('imposto', this.imposto);
  },

  computed: {
    perguntasFiltradasEquiparadoIndusrial() {
      //Seção de demais perguntas equiparado a industrial
      return this.imposto.perguntas.filter(
        pergunta => (pergunta.desabilita == 0 || pergunta.desabilita == 2) && pergunta.id_regra > 2
      );
    },

    labelEquiparadoIndustrial() {
      //label equiparado industrial vem do banco
      return this.imposto.perguntas.find(pergunta => pergunta.id_regra == 3);
    },

    perguntasFiltradasIndusrial() {
      return this.imposto.perguntas.filter(
        pergunta => pergunta.id_regra <= 2 && pergunta.label != "Não tributada"
      );
    },

    naoTributada() {
      return this.imposto.perguntas.find(pergunta => pergunta.label == "Não tributada");
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.ipi-perguntas-content {
  display: flex;
  align-items: flex-start;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}

.cabecalho-equiparado-industrial {
  margin-bottom: 1rem;
}

.separador-ipi {
  content: "";
  border: 1px solid var(--ipi);
  margin-bottom: 0.5rem;
  margin-left: 1.7rem;
}

.nao-tributada {
  margin-bottom: 1rem;
}

.cabecalho-nao-tributada {
  margin: 1rem 0 1rem 1.75rem;
}
</style>
